/*import axios from "axios";
let http = axios.create({
  baseURL: `https://colmenac.ugto.mx`,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default http;*/


import axios from 'axios'
import store from '@/store'

export const axiosSingleton = (function createSingleton() {
    let instance = null

    async function createInstance() {
        instance = axios.create({
            baseURL: `https://colmenac.ugto.mx`,
            withCredentials: false,
            headers: {
                Accept: 'application/json, multipart/form-data',
                'Content-Type': 'application/json',
            }
        })
        window.store = store.state.oidc
        window.axiosInstance = instance
            //console.log("Token:", store.state.oidc.access_token);
    }

    function getInstance() {
        if (!instance) { this.createInstance() }
        return instance
    }

    return {
        createInstance,
        getInstance
    }
})()